import { motion } from 'framer-motion';

const FancyNutsSection = () => {
  const products = [
    {
      name: 'Candied Nuts',
      description: 'Sweet, crunchy, and irresistible. A festival favorite.',
      image: 'https://customer-assets.emergentagent.com/job_slushd-refresh/artifacts/5z7iesw2_Candied%20Nuts.png',
    },
    {
      name: 'Soft Pretzels',
      description: 'Warm, soft, and perfectly salted. Fresh-baked goodness.',
      image: 'https://customer-assets.emergentagent.com/job_slushd-refresh/artifacts/3h2u3woa_Soft%20Pretzels.png',
    },
    {
      name: 'Jumbo Pickles',
      description: 'Crisp, tangy, and refreshingly bold. A crowd pleaser.',
      image: 'https://customer-assets.emergentagent.com/job_slushd-refresh/artifacts/jvftxq3v_Jumbo%20Pickles.png',
    },
  ];

  return (
    <section 
      id="fancy-nuts" 
      data-testid="fancy-nuts-section"
      className="relative py-24 md:py-32 bg-[#0a0a0a] noise-bg overflow-hidden"
    >
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-[#D4A574] text-sm font-medium tracking-widest uppercase mb-4 block">
            More From Us
          </span>
          
          {/* Fancy Nuts Logo */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mb-10"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_slushd-refresh/artifacts/mcvdt7cw_Fancy%20Nuts%20Logo.png"
              alt="Fancy Nuts"
              className="h-56 md:h-72 mx-auto object-contain bg-transparent"
              style={{ background: 'none', mixBlendMode: 'normal' }}
              data-testid="fancy-nuts-logo"
            />
          </motion.div>
          
          <p className="text-white/70 text-lg max-w-2xl mx-auto">
            Complete your event experience with our delicious snack offerings. 
            Available alongside SLUSHd at your next festival or event.
          </p>
        </motion.div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <motion.div
              key={product.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group text-center rounded-2xl bg-white/5 border border-[#D4A574]/20 hover:border-[#D4A574]/50 transition-all duration-300 overflow-hidden"
              data-testid={`fancy-nuts-product-${index}`}
            >
              <div className="relative h-48 overflow-hidden">
                <div 
                  className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
                  style={{ backgroundImage: `url(${product.image})` }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-white mb-3 uppercase tracking-wide">
                  {product.name}
                </h3>
                <p className="text-white/60 leading-relaxed">
                  {product.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-12 text-center"
        >
          <a 
            href="#contact"
            data-testid="fancy-nuts-cta"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#D4A574] text-black font-bold uppercase tracking-wider hover:bg-[#C49464] transition-all duration-300"
          >
            Add to Your Event
          </a>
        </motion.div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-1/2 -translate-y-1/2 -left-32 w-64 h-64 rounded-full bg-[#D4A574]/10 blur-[100px]" />
      <div className="absolute top-1/2 -translate-y-1/2 -right-32 w-64 h-64 rounded-full bg-[#D4A574]/10 blur-[100px]" />
    </section>
  );
};

export default FancyNutsSection;
